import React, { useEffect, Suspense } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
// import { useDispatch, useSelector } from 'react-redux'
import { Skeleton } from 'antd'
// import Header from './Header'
// import Survey from './Survey'
// import { APP } from '../redux/actionTypes'
// import { RootState } from '../redux/store'
// import request from '../utils/request'

type Props = {
  routes: Routes
}

const H5Layout: React.FC<Props> = ({ routes, ...rest }) => {
  // const { userInfo, resourceName } = useSelector((state: RootState) => state.app)
  // const dispatch = useDispatch()
  // 用户信息
  useEffect(() => {
    // if (!userInfo || !userInfo.user) {
    //   dispatch({ type: APP.GET_USER_INFO })
    // }
    // if (!resourceName) {
    //   dispatch({ type: APP.GET_RESOURCE_NAME })
    // }
    // request('noticeAccount', {})
  }, [])
  return (
    <div className="container">
      <div>
        <Suspense fallback={<Skeleton active></Skeleton>}>
          <Switch>
            <Redirect exact from="/h5" to="/h5/report/detail" />
            {routes.map(route => (
              <Route
                // exact
                key={route.path}
                path={route.path}
                render={props => <route.component {...props} {...rest} routes={route.routes} />}
              />
            ))}
          </Switch>
        </Suspense>
      </div>
    </div>
  )
}

export default H5Layout
